import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { billingApi } from '@/services/api/billingApi';
import { queryKeys } from '@/services/api/queryClient';
import toast from 'react-hot-toast';
import { extractErrorMessage } from '@/utils/extractErrorMessage';

export const useSubscriptionStatus = () => {
  return useQuery({
    queryKey: queryKeys.billingStatus,
    queryFn: billingApi.getSubscriptionStatus,
    staleTime: 5 * 60 * 1000,
  });
};

export const usePaymentHistory = () => {
  return useQuery({
    queryKey: queryKeys.billingPayments,
    queryFn: billingApi.getPaymentHistory,
    staleTime: 5 * 60 * 1000,
  });
};

export const useCreatePayment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (returnUrl: string) => billingApi.createPayment(returnUrl),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.billingStatus });
      queryClient.invalidateQueries({ queryKey: queryKeys.billingPayments });
    },
    onError: (err) => toast.error(extractErrorMessage(err, 'Ошибка при создании платежа')),
  });
};

